import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core'
import { AhuState } from '@app/shared/models/common-models'

@Component({
  selector: 'app-calculated-icon',
  templateUrl: './calculated-icon.component.html',
  styleUrls: ['./calculated-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalculatedIconComponent implements OnInit {
  @Input() state: AhuState

  @Input() showTooltip = false

  iconName: string

  tooltipText: string

  ngOnInit(): void {
    this.iconName = this.getIcon(this.state)
    this.tooltipText = this.getTooltip(this.state)
  }

  private getIcon = (state: AhuState): string => {
    switch (state) {
      case AhuState.NotCalculated:
        return 'help_outline'
      case AhuState.Calculated:
        return 'done'
      case AhuState.CalculatedWithWarnings:
        return 'warning'
      case AhuState.CalculatedWithErrors:
        return 'error'
      default:
        return 'help_outline'
    }
  }

  private getTooltip = (state: AhuState): string => {
    switch (state) {
      case AhuState.NotCalculated:
        return 'UI.NoCalc'
      case AhuState.Calculated:
        return 'UI.OK'
      case AhuState.CalculatedWithWarnings:
        return 'UI.Warning'
      case AhuState.CalculatedWithErrors:
        return 'UI.Error'
      default:
        return 'UI.NoCalc'
    }
  }
}
